import { DrawerItem } from "@gisce/oficina-virtual-components"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom";
import {
	Email
} from "@mui/icons-material";
import { GroupedSideBar } from "./GroupedSideBar";
import { UngroupedSideBar } from "./UngroupedSideBar";
import useNewsletterPage from "@/components/Newsletter/useNewsletterPage";
import { useSettingsContext } from "@/components/Settings/hooks/useSettingsContext";

export const MainDrawerItems = () => {
  const Settings = useSettingsContext();
  const { t } = useTranslation();
  const location = useLocation();
  const { navigateManageNewsletters } = useNewsletterPage();

  return <>
    {Settings.sidebar?.groups ? <GroupedSideBar /> : <UngroupedSideBar />}

    {Settings?.newsletter?.enabled && <DrawerItem 
      icon={<Email />}
      label={t('common:text.newsletter_manage')}
      onClick={() => navigateManageNewsletters()}
      selected={location.pathname == t('common:url.newsletter')}
    />}
    
  </>
}